module.exports = __webpack_public_path__ + "img/scene-authentic.6dffae1c.svg";